import { RelativeTime } from "@/components/feed/feed-event-primitives";
import type { ClientNotificationItem } from "@garimpa/api/notifications/toClientNotification";

export function NotificationSubjectDetails({
  notification,
}: {
  notification: ClientNotificationItem;
}) {
  const { commentPreview } = notification.subject;

  return (
    <>
      {commentPreview ? (
        <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
          &ldquo;{commentPreview}&rdquo;
        </p>
      ) : null}
      <p className="text-xs text-muted-foreground mt-0.5">
        <RelativeTime date={notification.createdAt} />
      </p>
    </>
  );
}
